(() => {
  if (window.rvrRequiredSizeSelectionLoaded) return;
  window.rvrRequiredSizeSelectionLoaded = true;

  const getProductWrapper = (element) => element.closest('.thb-product-detail');

  const getSizeFieldset = (variantSelects) => (
    variantSelects.querySelector('fieldset[data-handle="talle"][data-rvr-size-selection-required="true"]')
  );

  const hasExplicitSizeSelection = (productWrapper) => {
    const requiredSizeFieldset = productWrapper?.querySelector(
      'fieldset[data-rvr-size-selection-required="true"]'
    );

    if (!requiredSizeFieldset) return true;
    return requiredSizeFieldset.dataset.rvrSizeSelected === 'true';
  };

  const setDynamicCheckoutState = (productWrapper, enabled) => {
    const paymentWrapper = productWrapper?.querySelector('.shopify-payment-button-wrapper');
    if (!paymentWrapper) return;

    paymentWrapper.classList.toggle('needs-size-disabled', !enabled);
    paymentWrapper.toggleAttribute('inert', !enabled);
    paymentWrapper.setAttribute('aria-disabled', String(!enabled));
  };

  const setQuantitySelectorState = (productWrapper, enabled) => {
    productWrapper.querySelectorAll('product-form[data-needs-size="true"] quantity-selector').forEach((quantitySelector) => {
      quantitySelector.classList.toggle('needs-size-disabled', !enabled);
      quantitySelector.toggleAttribute('inert', !enabled);
      quantitySelector.setAttribute('aria-disabled', String(!enabled));
    });
  };

  const syncPurchaseState = (productWrapper) => {
    if (!productWrapper) return;

    const sizeSelected = hasExplicitSizeSelection(productWrapper);
    const submitButtons = productWrapper.querySelectorAll('.single-add-to-cart-button');

    setQuantitySelectorState(productWrapper, sizeSelected);

    if (!sizeSelected) {
      submitButtons.forEach((button) => {
        if (!button.disabled) button.setAttribute('disabled', 'disabled');
      });
    }

    const hasEnabledSubmitButton = Array.from(submitButtons).some((button) => !button.disabled);
    setDynamicCheckoutState(productWrapper, sizeSelected && hasEnabledSubmitButton);
  };

  const markSizeSelected = (productWrapper) => {
    productWrapper.querySelectorAll('fieldset[data-rvr-size-selection-required="true"]').forEach((fieldset) => {
      fieldset.dataset.rvrSizeSelected = 'true';
    });

    productWrapper.querySelectorAll('variant-selects').forEach((variantSelects) => {
      variantSelects.dataset.rvrSizeSelected = 'true';
    });

    syncPurchaseState(productWrapper);
  };

  const observePurchaseButtons = (productWrapper) => {
    if (productWrapper.dataset.rvrPurchaseButtonsObserved === 'true') return;
    productWrapper.dataset.rvrPurchaseButtonsObserved = 'true';

    const observer = new MutationObserver(() => syncPurchaseState(productWrapper));
    productWrapper.querySelectorAll('.single-add-to-cart-button').forEach((button) => {
      observer.observe(button, { attributes: true, attributeFilter: ['disabled'] });
    });
  };

  const enforceSizeSelection = (variantSelects) => {
    if (variantSelects.dataset.rvrRequiredSizeSelection === 'true') return;

    const productWrapper = getProductWrapper(variantSelects);
    const productForm = productWrapper?.querySelector('product-form[data-needs-size="true"]');
    const sizeFieldset = getSizeFieldset(variantSelects);
    if (!productForm || !sizeFieldset) return;

    variantSelects.dataset.rvrRequiredSizeSelection = 'true';

    let pointerControl = null;
    let pointerControlWasChecked = false;

    const resolveRadioFromPointerTarget = (target) => {
      if (target.matches('input[type="radio"]')) return target;

      const label = target.closest('label[for]');
      if (!label || !sizeFieldset.contains(label)) return null;

      return document.getElementById(label.htmlFor);
    };

    variantSelects.addEventListener('pointerdown', (event) => {
      const radio = resolveRadioFromPointerTarget(event.target);
      if (!radio || !sizeFieldset.contains(radio)) return;

      pointerControl = radio;
      pointerControlWasChecked = radio.checked;
    }, true);

    variantSelects.addEventListener('click', (event) => {
      const radio = event.target.closest('input[type="radio"]');
      if (!radio || !sizeFieldset.contains(radio)) return;

      const shouldRefreshCurrentVariant = (
        (pointerControl === radio && pointerControlWasChecked) || event.detail === 0
      );

      pointerControl = null;
      pointerControlWasChecked = false;
      markSizeSelected(productWrapper);

      if (shouldRefreshCurrentVariant) {
        window.setTimeout(() => {
          radio.dispatchEvent(new Event('change', { bubbles: true }));
        }, 0);
      }
    }, true);

    const updateState = (event) => {
      if (event.target.closest('fieldset') === sizeFieldset && event.target.value) {
        markSizeSelected(productWrapper);
      }

      if (hasExplicitSizeSelection(productWrapper)) return;

      event.stopImmediatePropagation();
      syncPurchaseState(productWrapper);
    };

    variantSelects.addEventListener('change', updateState, true);
    observePurchaseButtons(productWrapper);
    syncPurchaseState(productWrapper);
  };

  const initialize = (scope = document) => {
    scope.querySelectorAll('variant-selects').forEach(enforceSizeSelection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initialize(), { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));

  document.addEventListener('submit', (event) => {
    const productWrapper = getProductWrapper(event.target);
    if (!productWrapper || hasExplicitSizeSelection(productWrapper)) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    syncPurchaseState(productWrapper);
  }, true);
})();
